<template>
  <div class="container-fluid">
    <Breadcrumbs main="Delete Session" :path="breadcrumbPath" />
    <div class="row m-0 width-100-p px-4 mt-20">
      <div class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4">
        <sessionDelete
          :stateProp="stateList"
          :monitoringPeriods="monitoringPeriods"
          :customerData="customerData"
          @filterHandle="filterHandle"
          @afterDelete="afterDelete"
          :hasCustomDate="true"
          :hasPeriod="false"
          :hasLocation="false"
          :hasCharger="true"
          v-on:selectedChargerInfo="selectedChargerInfo"
          v-on:tableColumns="tableColumns"
          v-on:showchildDropdownTable="showchildDropdownTable"
          />
          <DropdownTable
          v-if="childshowchildDropdownTable"
          :tableData="childDropdownTableData"
          :tableColumns="childDropdownTableColumn" />
      </div>

      <div class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4 mt-20">
        <unallocatedSessionDelete
          :stateProp="stateList"
          :monitoringPeriods="monitoringPeriods"
          :customerData="customerData"
          @filterHandle="filterHandle"
          @afterDelete="afterDelete"
          :hasCustomDate="true"
          :hasPeriod="false"
          :hasLocation="false"
          :hasCharger="true"
          v-on:selectedChargerInfo="selectedChargerInfo"
          v-on:tableColumns="tableColumns"
          v-on:showchildDropdownTable="showchildDropdownTable"
          />
      </div>


    </div>
    
  </div>


</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
import sessionDelete from "./sessionDelete.vue";
import DropdownTable from "./DropdownTable.vue";

import unallocatedSessionDelete from "./unallocatedSessionDelete.vue";

import userService from "@/services/user.service";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "users",
  components: {
    Breadcrumbs,
    sessionDelete,
    DropdownTable,
    unallocatedSessionDelete,
  },
  data() {
    return {
      childshowchildDropdownTable: false,
      childDropdownTableData: null,
      childDropdownTableColumn: null,
      breadcrumbPath: [
        {
          title: "Operation",
          disabled: true,
          href: "",
        },
        {
          title: "Delete Sessions",
          disabled: false,
          href: "/sessions",
          active: true,
        },
      ],
      monitoringPeriods: null,
      customerData: null,

    };
  },

  mounted() {
    this.getMonitoringPeriods();
    this.getCustomerData();
  },
 
  methods: {
    // dropdown table
    tableColumns(event) {
      this.childDropdownTableColumn = event;
    },
    selectedChargerInfo(event) {
      this.childDropdownTableData = event;
    },
    showchildDropdownTable(event) {
      this.childshowchildDropdownTable = event;
    },
    // dropdown table end


    async getMonitoringPeriods() {
      await userService.getMonitoringPeriods(null, "", 1, 50, true).then((res) => {
        this.monitoringPeriods = res;
      }).catch((err) => {
        console.log("err when get monitoring periods", err.message);
      });
    },

    async getCustomerData() {
      await userService.getCustomers(null).then((res) => {
        console.log("res when get customer data", res);
        this.customerData = res;
      }).catch((err) => {
        console.log("err when get customer data", err.message);
      });
    },

  },
};
</script>

<style></style>
